module.exports = __webpack_public_path__ + "media/images/cursos-e144a2280d7ca2120a70dc0fc9ef2022.png";